import { createContext, useContext } from "react";
import { assert } from "utils";

import { type ProgramsRepository } from "src/repositories/programs/ProgramsRepository";

export const ProgramsRepositoryContext =
  createContext<ProgramsRepository | null>(null);

export function useProgramsRepository(): ProgramsRepository {
  const repository = useContext(ProgramsRepositoryContext);
  assert(repository, "ProgramsRepositoryContext is missing");
  return repository;
}
